export default __webpack_public_path__ + "static/header-bg-cd2297b638cca7d63a14297633f0f48a.mp4";